import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addPhoto({ dispatch, commit }, { model, file, files }) {
    try {
      const data = new FormData();
      if (files) {
        files.forEach(file => {
          data.append('files[]', file);
        });
      } else {
        data.append('file', file, file.name);
      }
      data.append('model', JSON.stringify(model));
      this.isLoading = true;
      const response = await request.post('/photos', data);

      if (response.data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
